import Cookie from 'universal-cookie';
import axios from 'axios';
import platform from 'platform';
let locName, countryCode;

export const getLocation = async (res) => {
  const userId = res.user._id;
  const cookies = new Cookie();
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        axios
          .get(
            `https://api.openweathermap.org/data/2.5/weather?lat=${position.coords.latitude}&lon=${position.coords.longitude}&appid=69767795771243a927f54d6744ecf024`
          )
          .then((res) => {
            locName = res.data.name;
            countryCode = res.data.sys.country;
          })
          .catch((err) => {
            console.log(err);
          });

        axios
          .get('https://api.ipify.org/?format=json')
          .then((res) => {
            const data = {
              user: userId,
              loginHistory: {
                browserName: platform.name,
                browserVersion: platform.version,
                location: locName,
                country: countryCode,
                ip: res.data.ip,
                os: `${platform.os.family} ${platform.os.version}`,
              },
              err: '',
            };
            axios
              .post('/loginhistory', data, {
                headers: { 'Access-Control-Allow-Origin': '*' },
                withCredentials: true,
              })
              .then((res) => {
                cookies.set('access_token', res.token);
                localStorage.removeItem('validate');
                localStorage.removeItem('xyz');
                window.location.href = '/dashboard';
              });
          })
          .catch((err) => {
            console.log(err);
          });
      },
      (error) => {
        let err;
        switch (error.code) {
          case error.PERMISSION_DENIED:
            err = 'User Denied';
            break;
          case error.POSITION_UNAVAILABLE:
            err = 'Loc. info. is unavailable.';
            break;
          case error.TIMEOUT:
            err = 'Time Out';
            break;
          case error.UNKNOWN_ERROR:
            err = 'Unknown error';
            break;
          default:
            break;
        }
      }
    );
  } else {
    window.alert('Geolocation is not supported by this browser.');
  }
};
